wbApp.controller('SentEmailsGroupDetailCtrl', ['$scope', '$translate', '$filter', '$modal', 'sentEmailsSvc',
function ($scope, $translate, $filter, $modal, sentEmailsSvc) {

    $scope.sentEmailsGroupGridSettings = {
        columns: [
            {
                dataField: 'name',
                caption: $translate.instant('TXT_HUMAN_NAME'),
                dataType: 'string',
                width: '160px'
            },
            {
                dataField: 'email',
                caption: $translate.instant('TXT_LBL_EMAIL'),
                dataType: 'string',
                width: '160px'
            },
            {
                dataField: 'status',
                caption: $translate.instant('TXT_LBL_STATE'),
                dataType: 'number',
                calculateCellValue: function (rowData) {
                    return $filter('emailStatus')(rowData.status);
                },
                width: '250px'
            },
            { dataField: 'response', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
            {
                dataField: 'updatedAt',
                caption: $translate.instant('TXT_LBL_UPDATED_AT'),
                dataType: 'date',
                format: 'shortDateShortTime',
                width: '130px',
                sortOrder: 'desc'
            }
        ],
        customCommands: [{
            text: $translate.instant('TXT_DETAIL'),
            callback: function (row) { onShowDetail(row.id); }
        }]
    }
     
    function onShowDetail(id) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.detail = sentEmailsSvc.getDetail(id);
            detailDialogPromise.show();
        });
    }

    $scope.onEmailSelected = function (model) {
    }

    var detailDialogPromise = $modal({
        templateUrl: 'messages/sent-emails-email-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
